export default __webpack_public_path__ + "8623418cf3e169f3e05dcb0de42448ac.png";